import React, {useState} from "react"
import {FieldEditableMode, FieldEditableProps} from "../../../../../proto/render/editable";
import {FieldViewSize} from "../../../../../const";
import EditableInput from "../../../../string/render/inline-editable/input-component";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";


const debug = false
// const debug = "FieldUrl_Editable"

export default function FieldUrl_Editable(props:FieldEditableProps) {

    // STATE & hovered
    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const value         = props.field.getViewValue(props.model)
    const displayValue  = props.field.getDisplayValue(value)

    const onMouseEnter = () => {
        debug && console.log(debug, 'onMouseEnter', mode)

        if (mode === FieldEditableMode.VIEW) {
            if (props.disabled || !props.field.canEdit(props.model)) {
                setMode(FieldEditableMode.HOVERED_VIEW)
            } else {
                setMode(FieldEditableMode.HOVERED)
            }
        }
    }

    const onMouseLeave = () => {
        if (mode === FieldEditableMode.HOVERED || mode === FieldEditableMode.HOVERED_VIEW) {
            setMode(FieldEditableMode.VIEW)
        }
    }

    const onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (props.disabled || !props.field.canEdit(props.model)) return false

        if (mode !== FieldEditableMode.EDITING) setMode(FieldEditableMode.EDITING)
    }

    const onOpenClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        let url = value;

        if (url.substring(0,4) !== 'http' && !url.includes('://')) {
            url = 'http://'+url
        }

        gd.openInNewWindow(url)
    }

    const onChange = (newValue:any) => {
        props.onChange && props.onChange(newValue)

        setMode(FieldEditableMode.VIEW)
    }

    const classes = Classes("ui5-field-editable", props.className, {
        "ui5-txt-default"               : props.size === FieldViewSize.DEFAULT,
        "size-default"                  : props.size === FieldViewSize.DEFAULT,
        "ui5-txt-less-important-small"  : props.size === FieldViewSize.SMALL,
        "size-small"                    : props.size === FieldViewSize.SMALL,
    })

    const renderEditing = () => {

        return (
            <div className="gd-custom-field-input-based w-100-percent">
                <EditableInput className="ui5-txt-default ui5-field-form-editable w-100-percent h-36" // p-l-10 p-r-10
                               inputClassName="ui5-txt-default"
                               value={value}
                               focusOnMount={true}
                               placeholder={props.field.placeholder}
                               onChange={onChange}/>
            </div>
        )
    }

    const renderHovered = () => {

        const hoveredClasses = Classes(classes, "is-hovered")

        return (
            <div className={hoveredClasses} onClick={onClick} onMouseLeave={onMouseLeave}>
                <div className="flex-row-center-space-between w-100-percent h-100-percent ">
                    <div className="max-w-100-percent txt-truncate">{displayValue}</div>
                    {displayValue && <div className="ui5-ico-14 link i5-open-new-window m-l-5" onClick={onOpenClick}/>}
                </div>
            </div>
        )
    }

    const renderHoveredView = () => {
        return (
            <div className={classes} onMouseLeave={onMouseLeave} onClick={onClick}>
                <div className="flex-row-center-space-between w-100-percent h-100-percent">
                    <div className="max-w-100-percent txt-truncate">{displayValue}</div>
                    {displayValue && <div className="ui5-ico-14 link i5-open-new-window m-l-5" onClick={onOpenClick}/>}
                </div>
            </div>
        )
    }

    const renderView = () => {

        return (
            <div className={classes} onMouseEnter={onMouseEnter} onClick={onClick}>

                <div className="flex-row-left-center w-100-percent h-100-percent ">
                    <div className="max-w-100-percent txt-truncate">{displayValue}</div>
                </div>
            </div>
        )
    }

    debug && console.log(debug, 'render', mode)

    switch (mode) {
        case FieldEditableMode.EDITING:
            return renderEditing()
        case FieldEditableMode.HOVERED:
            return renderHovered()
        case FieldEditableMode.HOVERED_VIEW:
            return renderHoveredView()
        case FieldEditableMode.VIEW:
        default:
            return renderView()
    }
}
